'use client';

import { RenderAd } from '@pickleballinc/ui/components/advertisements/render-ad';

import { IS_PRODUCTION } from '@/components/constants/constants';
import { ZONE_IDS_PTL } from '@/lib/ads.types';
import { PLACEMENT_IDS_PTL } from '@/lib/freestar.ptl.types';
import { useLocation } from '@/lib/location/location';

interface AdvertisementBannerProps {
	isHomepage?: boolean;
}

export const AdvertisementBanner = ({ isHomepage }: AdvertisementBannerProps) => {
	const { location } = useLocation();

	return (
		<RenderAd
			placementId={PLACEMENT_IDS_PTL.leaderboard_atf}
			zoneId={ZONE_IDS_PTL.PROG_BANNER}
			pageId={100009}
			place={0}
			ipAddress={location?.query}
			isProd={IS_PRODUCTION}
			containerClassname={`mx-auto w-full pt-4 ${isHomepage ? 'px-4' : ''}`}
			showFromWidth={600}
		/>
	);
};
